module.exports = __webpack_public_path__ + "0b2ff1eeb35cba3768963f4c24067267.pdf";